module.exports = __webpack_public_path__ + "static/media/RW.feb39a28.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/RW.svg
// module id = 350
// module chunks = 0